import { Drawer } from "antd";
import { GeneralStore } from "../stores";
import { MainSidebarItems, ProfileDropdown, SidebarLogoutButton } from "../sharedComponents";

export const MobileSidebar = () => {
  const { mobileSidebarOpen, setMobileSidebarOpen } = GeneralStore();

  return (
    <Drawer
      className="md:hidden spor-mobile-drawer"
      zIndex={4000}
      open={mobileSidebarOpen}
      onClose={() => setMobileSidebarOpen(false)}
      placement="left"
      width={260}
      styles={{
        body: {
          padding: 0,
          background: "#fff",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        header: { display: "none" },
        footer: { display: "none" },
      }}
    >
      <div className="spor-mobile-drawer-shell">
        <div className="spor-mobile-drawer-scroll">
          <MainSidebarItems />
        </div>
        <div className="spor-mobile-drawer-footer">
          <ProfileDropdown showDetails interactive={false} />
          <SidebarLogoutButton collapsed={false} />
        </div>
      </div>
    </Drawer>
  );
};
